import { render, staticRenderFns } from "./VueTypeaheadBootstrapListItem.vue?vue&type=template&id=cbf646c4&scoped=true"
import script from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js"
export * from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js"
import style0 from "./VueTypeaheadBootstrapListItem.vue?vue&type=style&index=0&id=cbf646c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf646c4",
  null
  
)

export default component.exports